module.exports = __webpack_public_path__ + "img/koeun-logo.4bbadf23.svg";